export enum MostrarTooltipSiloEnum {
    BLOCK = 'block',
    HIDDEN = 'hidden',
}
